import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { fixedValues } from 'src/app/shared/constants/fixed-values.enum';
import { CommonService } from '../../../services/common.service';
import { LangService } from 'src/app/core/services/lang.service';
import { GridService } from 'src/app/shared/services/grid.service';
@Component({
  selector: 'app-cheque-no',
  templateUrl: './../../../templates/forms/modals/voucher-no-list.component.html',
})
export class VoucherNoListComponent implements OnInit {
  @Input()
  config:any;

  @Input()
  modalShow: boolean = true;

  @Input()
  startDate:string;
  endDate:string;

  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  searchFields: any[] = ['V_ID','V_NO'];
  public searchString;

  dataObj:any;

  voucherList: any[] = [];

  columnDefs = [];
  colObj;
  grid: any;
  gridId: string = "PayToNameListGrid"

  constructor(public langService: LangService,
     private comService: CommonService, 
     public gridService:GridService) {
      this.colObj = [
        { headerName: langService.langData.voucherId, field: 'V_ID', sortable: true, resizable: true, hide: false },
      ];

  }
 
  ngOnInit() {
    this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId);
  }
  onGridReady(grid) {
    this.grid = grid;
    this.gridService.sizeColumnsToFit(grid, this.gridId);

    this.comService.getVouchersNo(this.startDate,this.endDate).subscribe(result => {
      this.voucherList = result.body;
    });
  }
  itemClick(_item) {
    this.modalShow = false;
    this.dataObj = _item;
    this.submit.next();
  }

}
